import { useTranslation } from 'react-i18next';
import { isElalCompany } from '@/utils/isCompany';

const PrivateTravelBookingsHeader = () => {
    const { t } = useTranslation();
    const isElal = isElalCompany();

    return (
        <div className="private-travel-bookings-component">
            <div className="private-travel-bookings-component__container">
                <div className="private-travel-bookings-component__title">{t('PrivateTravel.Title')}</div>
                <div className="private-travel-bookings-component__description">{t('PrivateTravel.Description')}</div>
            </div>

            {isElal && (
                <div className="elal-bookings-notice">
                    <div className="elal-bookings-notice__content">{t('FrequentFlyerBookingNotice')}</div>
                    <div className="elal-bookings-notice__content">{t('ToViewTheAccumulation')}</div>
                </div>
            )}
        </div>
    );
};

export default PrivateTravelBookingsHeader;
